import { Link } from 'react-router-dom';
import { ChatConversation } from '../features/Chatbot/ChatConversation';
import { useEmergencyMode } from '../features/Chatbot/useEmergencyMode';
import styles from './ChatPage.module.css';

export function ChatPage() {
  const emergency = useEmergencyMode();
  return (
    <main className={styles.main}>
      <div className={styles.topBar}>
        <div className="wrap">
          <Link to="/" className={styles.back} aria-label="돌아가기">
            <svg
              className={styles.backIcon}
              width="14"
              height="14"
              viewBox="0 0 16 16"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M13 8H3M7 4L3 8l4 4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>돌아가기</span>
          </Link>
        </div>
      </div>

      <div className={styles.layout}>
        <aside className={styles.intro}>
          <span className={`${styles.eyebrow} ${emergency ? styles.eyebrowAlert : ''}`}>
            <span className={styles.eyebrowDot} aria-hidden="true" />
            {emergency ? '야간 응급 상담 모드' : '담당자 상담 중 · 평일 09–21시'}
          </span>
          <h1 className={styles.title}>
            {emergency ? (
              <>
                야간에도 의무기록을 읽는
                <br />
                변호사가 응답합니다.
              </>
            ) : (
              <>
                의무기록을 읽는
                <br />
                변호사가 응답합니다.
              </>
            )}
          </h1>

          <blockquote className={styles.quote}>
            <p>
              일반 변호사는 <strong>의무기록을 읽지 못합니다.</strong>
              <br />
              의료분쟁은 법률 문제이기 이전에 <strong>임상 판단의 문제</strong>입니다.
            </p>
            <p className={styles.quoteLine}>
              우리는 같은 의료 현장을 경험한 동료로서,
              <br />
              변호사의 언어로 지킵니다.
            </p>
          </blockquote>

          <ul className={styles.infoList}>
            <li>
              <strong>담당</strong>
              <span>의사 출신 변호사</span>
            </li>
            <li>
              <strong>대응 범위</strong>
              <span>분쟁·처분·형사·자문</span>
            </li>
            <li>
              <strong>초기 상담</strong>
              <span>무료</span>
            </li>
          </ul>

          <div className={styles.note}>
            메디로이어는 <strong>법무법인 오킴스</strong>가 제공하는 의료인 전용 응급 상담
            서비스입니다.
          </div>
        </aside>

        <div className={styles.chatPanel}>
          <ChatConversation variant="page" />
        </div>
      </div>
    </main>
  );
}
